import { type FilterCategory } from "../config";

export const customFilterCategory = {
  id: "custom",
  title: "Andre filtre",
  icon: null,
  description: "Tilvalgte og unikke filtre",
  filters: {},
} satisfies FilterCategory;
